<template>
<div>
	<div class="my-1 row">

		<div class="col-md-4">
			<h1 class="display-4">{{ $t('common.bids') }}</h1>
		</div>

		<div class="col-sm-8">
			<b-pagination-nav :link-gen="linkGen"
			                  :number-of-pages="bids.meta.totalPages"
			                  :value="bids.meta.currentPage"
			                  use-router
			                  class="pull-right" />
		</div>
	</div>

	<partial-loader :loading="bids.isFetching"></partial-loader>

	<b-table v-if="!bids.isFetching"
			 
			striped
			hover
			show-empty
			:items="bids.data"
			:fields="fields"
			:per-page="parseInt(bids.meta.perPage)"
			:sort-by.sync="sortBy"
			:sort-desc.sync="sortDesc"
			:busy="bids.isFetching"
			:empty-text="$t('bid.listEmptyText')"
			:empty-filtered-text="$t('bid.listEmptyFilteredText')">

		<template v-slot:cell(created_at)="row">
 				  {{ row.item.created_at | smallDate }}
 		</template>

		<template v-slot:cell(item)="row">
				<router-link :to="{ name: 'item', params: { itemId: row.item.item.id } }">
					<strong>{{ row.item.item.seller.code }}-{{ row.item.item.number }}</strong> {{ row.item.item.title }}
				</router-link>
		</template>

		<template v-slot:cell(actions)="row">

			<b-btn-group class="pull-right">

				<b-btn variant="outline-danger"
					   @click="showDeleteModal(row.item)">
					   <i class="fa fa-fw fa-trash"></i>
				</b-btn>

				<b-btn exact
					   variant="outline-primary"
					   :to="{ name: 'bidEdit', params: { bidId: row.item.id, itemId: row.item.item.id } }">
					<i class="fa fa-fw fa-edit"></i>
				</b-btn>

			</b-btn-group>

		</template>
	</b-table>

	<delete-dialog-modal ref="deleteModal"
	                     :delete-name="selectedDeleteItemName"
	                     :item="selectedDeleteItem"
	                     :isDeleting="isDeleting"
	                     @confirm="deleteBid"></delete-dialog-modal>

	<b-pagination-nav :link-gen="linkGen"
	                  :number-of-pages="bids.meta.totalPages"
	                  :value="bids.meta.currentPage"
	                  use-router
	                  class="pull-right" />

	<p hidden>
		Sort By: {{ sortBy || 'n/a' }}, Direction: {{ sortDesc ? 'descending' : 'ascending' }}
	</p>

</div>
</template>

<script>
import { isNil } from 'lodash';
import { createNamespacedHelpers } from 'vuex';
import { flashSuccess, flashDanger } from '@/helpers/flash-message-helper';
import PartialLoader from '@/components/elements/PartialLoader';
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';
import { smallDate } from '@/filters/date-filters';

const { mapGetters, mapActions } = createNamespacedHelpers('bidList');

export default {
	components: {
		PartialLoader,
		DeleteDialogModal
	},
	filters: {
		smallDate
	},
	data() {
		return {
			fields: [
				{ key: 'created_at', label: this.$t('common.date') },
				{ key: 'price', label: this.$t('common.price') },
				{ key: 'bid_number', label: this.$t('bid.bidNumber') },
				{ key: 'buyer.full_name_simple', label: this.$t('common.buyer') },
				{ key: 'item', label: this.$t('common.item') },
				{ key: 'actions', label: this.$t('common.actions') }
			],
			currentPage: 1,
			perPage: 50,
			sortBy: 'id',
			sortDesc: true,
			selectedDeleteItem: null
		}

	},
	computed: {
		...mapGetters([
			'bids',
			'isDeleting'
		]),
		selectedDeleteItemName() {
			if (!this.selectedDeleteItem) return '';

			return this.$t('bid.deleteBidOn', { title: `${this.selectedDeleteItem.item.seller.code}-${this.selectedDeleteItem.item.number} ${this.selectedDeleteItem.item.title}` });
		}
	},
	watch: {
		'$route': 'fetchData',
		'filter': 'filterData'
	},
	methods: {
		...mapActions({
			fetchAuctionBids: 'fetchAuctionBids',
			nextPageAuctionBids: 'nextPageAuctionBids',
			deleteBidAction: 'deleteBid'
		}),

		/**
		 * Generate link for pagenumber
		 * @param  {integer} pageNumber page number that needs to be included in link
		 * @return {string}             link to a page
		 */
		linkGen(pageNumber) {
			return '?page=' + pageNumber;
		},

		/**
		 * Show delete modal for the bid
		 * @param  {Object} bid
		 */
		showDeleteModal(bid) {
			this.selectedDeleteItem = bid;
			this.$refs.deleteModal.show();
		},

		/**
		 * Delete the bid and refresh the bids
		 * @param  {Object} bid  Bid that will be deleted
		 * @return {Promise}
		 */
		deleteBid(bid) {

			return this.deleteBidAction({ itemId: bid.item.id, bidId: bid.id })
				.then(() => {

					this.$refs.deleteModal.hide()
					this.fetchData();
					this.selectedDeleteItem = null;
					flashSuccess(this.$t('bid.deleteSuccess'));

				});
		},

		/**
		 * Fetch the bids
		 * @return {Promise} returns a promise that will be resolved when bids are fetched
		 */
		fetchData() {
			const params = this.$route.params;
			const query = this.$route.query;

			const currentPage = Number.parseInt(query.page);
			this.currentPage = isNaN(currentPage) ? 1 : currentPage;

			return this.fetchAuctionBids({
				auctionId: params.auctionId,
				params: {
					total: this.perPage,
					page: this.currentPage,
					query: null,
					sort: this.sortBy,
					order: this.sortDesc ? 'desc' : 'asc'
				}
			});
		}
	},
	created() {
		this.fetchData();
	}
}
</script>



// WEBPACK FOOTER //
// BidList.vue?f2fec4d8